import date from 'date-and-time';
import { atMinutes, minutesOfDay, parseDayKey } from './calendarDates';

/** The step of a move in the Week view and of a drop on a Week hour (design a2). */
export const WEEK_STEP_MINUTES = 15;

/**
 * The new time of a post that moves to a day. In Month the post keeps its time of day; in Week
 * the drop gives the time too (`minutes` after midnight, rounded to 15 minutes).
 */
export function movedTime(scheduledAt: string, targetDayKey: string, minutes?: number): Date | null {
  const day = parseDayKey(targetDayKey);
  if (day === null) {
    return null;
  }
  const current = new Date(scheduledAt);
  const target =
    minutes === undefined ? minutesOfDay(current) : Math.round(minutes / WEEK_STEP_MINUTES) * WEEK_STEP_MINUTES;
  return atMinutes(day, Math.min(Math.max(target, 0), 24 * 60 - WEEK_STEP_MINUTES));
}

/**
 * True when a post may go to this time: only a time ahead of now (design b6). A drop on today
 * keeps the time when it is still ahead; a day before today refuses the drop.
 */
export function canDropAt(target: Date | null, now: Date = new Date()): target is Date {
  return target !== null && target.getTime() > now.getTime();
}

/** True when the time is a real move: another time than the post has now. */
export function isRealMove(scheduledAt: string, target: Date): boolean {
  return Math.abs(new Date(scheduledAt).getTime() - target.getTime()) >= 60_000;
}

export type KeyboardMoveKey = 'ArrowLeft' | 'ArrowRight' | 'ArrowUp' | 'ArrowDown';

/**
 * The next time of a held post for an arrow key. Month: left and right move one day, up and down
 * one week. Week: left and right one day, up and down 15 minutes. Shift and left or right move one
 * week in both views.
 */
export function keyboardMoveTime(current: Date, key: KeyboardMoveKey, view: 'month' | 'week', shift: boolean): Date {
  const sign = key === 'ArrowLeft' || key === 'ArrowUp' ? -1 : 1;
  if (key === 'ArrowLeft' || key === 'ArrowRight') {
    return date.addDays(current, sign * (shift ? 7 : 1));
  }
  if (view === 'week') {
    return date.addMinutes(current, sign * WEEK_STEP_MINUTES);
  }
  return date.addDays(current, sign * 7);
}
